import { EmptyCheckmarkIcon, FilledCheckmarkIcon } from '@va/icons';
import { TooltipWrapper } from '@va/ui/tooltips';
import classNames from 'classnames';
import { ChangeEvent, ReactNode } from 'react';
import { InputMessage } from '../text-input/TextInput';

type CheckboxProps = {
  value: boolean;
  onChange: (newValue: boolean) => void;
  label: string;
  name: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  labelClassName?: string;
  wrapperClassName?: string;
  dataTestId?: string;
  tooltip?: ReactNode;
};

const CheckmarkIcon = ({ checked }: { checked: boolean }) => {
  return checked ? <FilledCheckmarkIcon /> : <EmptyCheckmarkIcon />;
};

export function Checkbox({
  value,
  onChange,
  label,
  name,
  error,
  required,
  disabled,
  labelClassName,
  wrapperClassName,
  dataTestId,
  tooltip,
}: CheckboxProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <div className={classNames(wrapperClassName)}>
      <TooltipWrapper content={tooltip} disabled={!tooltip} trigger='hover'>
        <div
          className={classNames('flex flex-row justify-start flex-nowrap items-center gap-3 w-fit', {
            'opacity-50': disabled,
          })}
        >
          <div
            onClick={() => {
              if (disabled) return;
              onChange(!value);
            }}
          >
            <CheckmarkIcon checked={value} />
          </div>
          <label className={classNames('text-12', labelClassName)}>
            <input
              data-testid={dataTestId}
              type='checkbox'
              name={name}
              checked={value}
              onChange={handleChange}
              disabled={disabled}
            />
            {label} {required && <span className='text-red-pure'>*</span>}
          </label>
        </div>
      </TooltipWrapper>
      <InputMessage error={error} />
    </div>
  );
}
